import React from 'react';

const AgentInvoice = () => {
	return <div>AgentInvoice</div>;
};

export default AgentInvoice;
